export default __webpack_public_path__ + "static/media/factory__51.ed81e39c.jpg";